import { Box, Space } from "@mantine/core";

interface ListNotificationsLayoutProps {
  title?: any;
  content: any;
  onNavigate?: () => void;
}
const ListNotificationsLayout = ({
  title,
  content,
  onNavigate,
}: ListNotificationsLayoutProps) => {
  return (
    <>
      <Box onClick={onNavigate}>
        {/* <Group position="apart" mb={16}>
        <Text weight={600} size={14} color="#111827" mt={16}>
          {title}
        </Text>
      </Group> */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {content}
        </Box>
      </Box>
      <Space h={10} />
    </>
  );
};

export default ListNotificationsLayout;
